import React from "react";
import DMCalendar from "./DMCalendar";
import "../assets/css/DigixLeads.css";
import "../assets/css/Projects.css";
import "../assets/css/MyDay.css";

/**
 * Standalone CRM page: Digital Marketing only (DM calendar + tenant filter).
 * Same calendar component is embedded on the Dashboard "DM Calendar" tab.
 */
function DigitalMarketingPage() {
  return (
    <div className="projects-container">
      <div className="main-card digital-marketing-page">
        <DMCalendar title="Digital Marketing" />
      </div>
    </div>
  );
}

export default DigitalMarketingPage;
